/**
* Do not edit directly
* Generated on Fri, 10 Mar 2023 21:41:50 GMT
*/

module.exports = {
  "colors": {
    "text": {
      "brand": "#28807a",
      "heading": "#1e1e1e",
      "body": "#4c4c4c"
    },
    "btn-brand": {
      "50": "#d8efec",
      "100": "#c1e6e2",
      "200": "#aadcd7",
      "300": "#78c4bd",
      "400": "#43a099",
      "500": "#28807a",
      "600": "#217771",
      "700": "#196964",
      "800": "#105551",
      "900": "#073e3b",
      "fontColor": "#fff"
    },
    "link": {
      "color": "#1260a2",
      "hover": {
        "color": "#033965"
      }
    },
    "input": {
      "background": "#fff",
      "border": "#687586",
      "placeholder": "#c6d3e2",
      "text": "#232830",
      "hover": {
        "border": "#606c7c"
      }
    },
    "btn-primary": {
      "50": "#d7edff",
      "100": "#c2e4ff",
      "200": "#a8d7ff",
      "300": "#75bcff",
      "400": "#3e96e8",
      "500": "#2177c2",
      "600": "#1a6eb5",
      "700": "#1260a2",
      "800": "#094e86",
      "900": "#033965",
      "fontColor": "#fff"
    },
    "btn-secondary": {
      "50": "#f5f5f5",
      "100": "#ebebeb",
      "200": "#ebebeb",
      "300": "#ebebeb",
      "400": "#ebebeb",
      "500": "#ebebeb",
      "600": "#e0e0e0",
      "700": "#d2d2d2",
      "800": "#b6b6b6",
      "900": "#929292",
      "fontColor": "#1a6eb5"
    },
    "btn-danger": {
      "50": "#ffe5e0",
      "100": "#ffd6cd",
      "200": "#ffc5b9",
      "300": "#ff9c8b",
      "400": "#f06655",
      "500": "#d8362f",
      "600": "#ce2726",
      "700": "#bd0f1a",
      "800": "#9e0010",
      "900": "#75030a",
      "fontColor": "#fff"
    }
  },
  "radii": {
    "0": "0",
    "input": {
      "xs": "0.25rem",
      "sm": "0.375rem",
      "md": "0.375rem",
      "lg": "0.375rem"
    },
    "none": "0",
    "2xs": "0.0625rem",
    "xs": "0.125rem",
    "sm": "0.25rem",
    "md": "0.375rem",
    "lg": "0.5rem",
    "xl": "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    "full": "624.9375rem"
  },
  "semanticTokens": {
    "colors": {
      "background": "radial-gradient(88.02% 32.04% at 50% 7.61%, #FFFFFF 0%, #E9E9EC 100%)",
      "warning": "#af5f22",
      "success": "#007d0e",
      "danger": "#ce2726"
    }
  },
  "breakpoints": {
    "base": "0",
    "sm": "26.25rem",
    "md": "40rem",
    "lg": "53.75rem",
    "xl": "67.5rem",
    "2xl": "81.25rem"
  },
  "space": {
    "spacing-0": "0",
    "spacing-25": "0.0625rem",
    "spacing-50": "0.125rem",
    "spacing-100": "0.25rem",
    "spacing-200": "0.5rem",
    "spacing-400": "1rem",
    "spacing-600": "1.5rem",
    "spacing-800": "2rem",
    "spacing-1200": "3rem",
    "spacing-1800": "4.5rem",
    "spacing-2400": "6rem",
    "spacing-3000": "7.5rem",
    "spacing-3600": "9rem",
    "spacing-4200": "10.5rem"
  },
  "fonts": {
    "heading": "Open Sans, Geneva, Verdana, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
    "body": "Open Sans, Geneva, Verdana, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
    "mono": "Operator Mono, Fira Code Retina, Bitstream Vera Sans Mono, ui-monospace, Menlo, Monaco, Cascadia Mono, Segoe UI Mono, Roboto Mono, Oxygen Mono, Ubuntu Monospace,Source Code Pro, Fira Mono, Droid Sans Mono, Courier New, monospace"
  },
  "fontSizes": {
    "3xs": "0.625rem",
    "2xs": "0.78125rem",
    "xs": "0.875rem",
    "sm": "0.9375rem",
    "md": "1.0625rem",
    "lg": "1.3125rem",
    "xl": "1.75rem",
    "2xl": "2.125rem",
    "3xl": "2.9375rem",
    "4xl": "3.625rem",
    "5xl": "4.9375rem",
    "6xl": "6rem"
  },
  "lineHeights": {
    "3xs": "160%",
    "2xs": "160%",
    "xs": "142.9%",
    "sm": "160%",
    "md": "141.2%",
    "lg": "152.4%",
    "xl": "142.9%",
    "2xl": "129.4%",
    "3xl": "102.1%",
    "4xl": "117.2%",
    "5xl": "121.5%",
    "6xl": "125%"
  },
  "letterSpacings": {
    "3xs": "0.012em",
    "2xs": "0em",
    "xs": "-0.0014000000000000002em",
    "sm": "-0.002em",
    "md": "-0.0026em",
    "lg": "-0.01em",
    "xl": "-0.012em",
    "2xl": "-0.015em",
    "3xl": "-0.017em",
    "4xl": "-0.015em",
    "5xl": "-0.006999999999999999em",
    "6xl": "-0.013000000000000001em",
    "allCaps": "0.1em"
  },
  "fontWeights": {
    "light": 300,
    "regular": 400,
    "semibold": 600,
    "bold": 700
  }
}